import { useCallback, useRef } from 'react';

import { _getBffContactById } from '@/api/address-book-bff/queries';
import type { ContactView } from '@/api/address-book-bff/types';
import { queryClient } from '@/app/providers/react-query-provider';
import { useToast } from '@/shared/design-system';

export function useCreatedContact<T>(
  map: (_contact: ContactView) => T,
  onResolved: (_value: T) => void,
) {
  const resolvedIdRef = useRef<string | null>(null);
  const { add: addToast } = useToast();

  return useCallback(
    (contactId: string) => {
      if (resolvedIdRef.current === contactId) return;
      resolvedIdRef.current = contactId;

      const { queryKey, queryFn } = _getBffContactById(contactId);
      queryClient
        .fetchQuery({ queryKey, queryFn })
        .then((contact) => onResolved(map(contact)))
        .catch(() => {
          resolvedIdRef.current = null;
          addToast({
            title: 'Contact saved, but could not be selected',
            description: 'Find it in the search field above.',
            data: { status: 'error' },
          });
        });
    },
    [map, onResolved, addToast],
  );
}
